<app-modal
  [open]="open()"
  [title]="'ATTACH_ALREADY_ACTIVATED_GATEWAY'"
  cancelLabel="CANCEL"
  confirmLabel="VALIDATE"
  [cancelDisabled]="loading"
  [confirmDisabled]="!formGroup.valid || loading"
  [confirmLoading]="loading"
  [confirmHint]="confirmHint"
  [disableBackdropClose]="loading"
  [showCloseIcon]="!loading"
  (cancelled)="cancel()"
  (confirmed)="submit()"
  (confirmHintVisible)="onConfirmHintVisible($event)"
>
  <form autocomplete="off" [formGroup]="formGroup">
    <app-tooltip
      placement="top"
      [disabled]="!pinValidationTooltip"
      [forceOpen]="showConfirmFieldHints"
      [openOnInteraction]="false"
    >
      <fieldset popover-trigger class="field pin-field">
        <legend class="field-label typography-body-medium">{{ 'CRITERIA_SEARCH_PIN_CODE' | translate }}</legend>

        <div class="pin-inputs" formArrayName="gatewayId" (paste)="onPinPaste($event)">
          @for (control of pinControls; track $index) {
            <input
              #pinInput
              required
              class="pin-code typography-body-regular"
              autocomplete="off"
              inputmode="numeric"
              type="text"
              [id]="'gatewayId-' + $index"
              [name]="'gatewayId-' + $index"
              [formControlName]="$index"
              [attr.aria-label]="('CRITERIA_SEARCH_PIN_CODE' | translate) + ' ' + ($index + 1) + '/' + pinSegmentCount"
              aria-describedby="gateway-pin-helper"
              mask="0000"
              placeholder="0000"
              (input)="onPinInput($index)"
              (keydown)="onPinKeydown($event, $index)"
            />
            @if (!$last) {
              <span class="pin-separator" aria-hidden="true">-</span>
            }
          }
        </div>

        <p id="gateway-pin-helper" class="field-helper typography-small-regular">
          <app-icon path="assets/icons/infos.svg" [size]="18" aria-hidden="true" />
          <span>{{ 'MODAL_ATTACH_GATEWAY_TEXT1' | translate }}</span>
        </p>
      </fieldset>
      <span>{{ pinValidationTooltip }}</span>
    </app-tooltip>

    <app-tooltip
      placement="top"
      [disabled]="!emailValidationTooltip"
      [forceOpen]="showConfirmFieldHints"
      [openOnInteraction]="false"
    >
      <label popover-trigger class="field" for="siteOwnerEmail">
        <span class="field-label typography-body-medium">{{ 'MODAL_ATTACH_GATEWAY_TEXT2' | translate }}</span>
        <input
          required
          class="email-input typography-body-regular"
          type="email"
          id="siteOwnerEmail"
          formControlName="siteOwnerEmail"
          name="siteOwnerEmail"
          (input)="clearRequestError()"
        />
      </label>
      <span>{{ emailValidationTooltip }}</span>
    </app-tooltip>

    <div class="information-callout typography-small-regular" role="note">
      <app-icon path="assets/icons/infos.svg" [size]="20" aria-hidden="true" />
      <p>{{ 'MODAL_ATTACH_GATEWAY_TEXT3' | translate }}</p>
    </div>

    @if (attachRequestErrorCode) {
      <p
        class="error-callout typography-small-regular"
        data-testid="link-request-error"
        role="alert"
        aria-live="assertive"
      >
        {{ generateLocalizedErrorKey() | translate }}
      </p>
    }
  </form>
</app-modal>
